import { render, staticRenderFns } from "./koPrivacy.vue?vue&type=template&id=79862057&scoped=true&"
import script from "./koPrivacy.vue?vue&type=script&lang=js&"
export * from "./koPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./koPrivacy.vue?vue&type=style&index=0&id=79862057&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79862057",
  null
  
)

export default component.exports